// extracted by css-extract-rspack-plugin
export default {"cls1":"blurred_takeaways-cls1_rVX","cls2":"blurred_takeaways-cls2_82D blurred_takeaways-cls1_rVX"};